export default __webpack_public_path__ + "static/media/TheDisarrangeCover-500x500.db9c321b.png";